import { IQuoteTabConfig } from '../../models/quotes/quote-tab.interface';
import { QuoteStatus } from '../../models/quotes/quote.interface';

// Ordered per the mockup's tab strip (plan §1/§8). Every tab but `audit`
// maps 1:1 onto GET /quotes?status=X (plan §6) - `Rejected` reads
// `QuoteStatus.Declined` per Revision 2, not a nested ApprovalStatus.
export const quoteTabsConfig: IQuoteTabConfig[] = [
  { key: 'quoteRequests', labelKey: 'QuoteRequests', status: QuoteStatus.Created },
  {
    key: 'pendingForApproval',
    labelKey: 'PendingForApproval',
    status: QuoteStatus.SubmittedForApproval
  },
  { key: 'approved', labelKey: 'Approved', status: QuoteStatus.Approved },
  { key: 'rejected', labelKey: 'Rejected', status: QuoteStatus.Declined },
  { key: 'cancelled', labelKey: 'Cancelled', status: QuoteStatus.Cancelled },
  { key: 'audit', labelKey: 'Audit' }
];

export default quoteTabsConfig;
